import { prepareRangeFiltersProps } from "../../../components/CustomSearch/utils";
import { OrderStatus } from "../../../pages/Orders/types";
import { DataProviderKey, IGetListParams } from "../../../types/reactAdmin.types";
import { AppResource } from "../../../types/resource.types";
import { getFinalList } from "../../../utils/collectionQuery";
import { firestore } from "../../firebase";

const ordersResource = {
  [AppResource.orders]: {
    [DataProviderKey.getList]: async (params: IGetListParams) => {
      let enhancedParams: IGetListParams = {
        ...params,
        additionalFilter: {
          brandId: params.user.id,
        },
      };

      return getFinalList(
        {
          ...prepareRangeFiltersProps(enhancedParams, ["totalPrice", "expectedDeliveryDate"]),
          limit: params.pagination.perPage,
        },
        firestore
          .collection(AppResource.orders)
          .where("status", "in", [
            OrderStatus.preparing,
            OrderStatus.delivered,
            OrderStatus.delivering,
            OrderStatus.canceled,
          ])
      );
    },
  },
};

export default ordersResource;
